import { Tab } from '@starsoft/common/src/components/Tabs/Tab/props';
import { RollCompetitionContentTabs } from './props';

export const rollCompetitionTabsOptions: Tab<RollCompetitionContentTabs>[] = [
  {
    label: 'leaderboard',
    value: RollCompetitionContentTabs.Information,
    icon: 'fa-duotone fa-award',
  },
  // {
  //   label: 'prizes_label',
  //   value: RollCompetitionContentTabs.Prizes,
  //   icon: 'fa-duotone fa-award',
  // },
  {
    label: 'last_rewards_label',
    value: RollCompetitionContentTabs.LastRewards,
    icon: 'fa-duotone fa-clock-rotate-left',
  },
];
